export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel }) {
  if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-slate-900 border border-slate-700 rounded-xl w-full max-w-md shadow-2xl p-6">
        <h3 className="text-xl font-bold text-white mb-4">{title}</h3>
        <p className="text-slate-400 mb-8">{message}</p>
        <div className="flex justify-end gap-3">
          <button onClick={onCancel} className="px-4 py-2 text-slate-400 font-bold hover:text-white transition">Cancelar</button>
          <button onClick={onConfirm} className="bg-rose-500 hover:bg-rose-600 px-6 py-2 rounded-lg text-white font-bold shadow-lg transition">Confirmar</button>
        </div>
      </div>
    </div>
  )
}
